/**
 * Created by Jaap on 07-12-2016.
 *
 *
 * Events that the message_api will listen to:
 * - "INIT"
 * - "START"
 * - "STOP"
 * - "ANIMATION_START"
 * - "ANIMATION_END"
 * - "TOGGLE_ON"
 * - "TOGGLE_OFF"
 * - "TRACK_EVENT"
 */
import Links from "./Links";
import UserEvents from "./UserEvents";
import { constructSceneUUID, constructUUID } from "./Utils";

export default class Embeds{

    constructor(scene){
        this.scene = scene;
        this.iframe_queue = [];
    }

    initEmbeds(){
        this.file_embeds = this.scene.runSelector(".embed .file-embed");
        this.url_embeds = this.scene.runSelector(".embed .url-embed");

        this.file_embeds
            .off("IFRAME_EMBED_MESSAGE")
            .on("IFRAME_EMBED_MESSAGE", (event, message) => this.embedMessageReceived(message))
        ;
        this.url_embeds
            .off("IFRAME_EMBED_MESSAGE")
            .on("IFRAME_EMBED_MESSAGE", (event, message) => this.embedMessageReceived(message))
        ;

        this.file_embeds.add(this.url_embeds).each(function(i, element){
            let jq_element = $(element);
            jq_element.attr('src', jq_element.data('src'));
        });

        try{
            this.scene.runSelector(".embed script").each((i, el) => {
                if(el.getAttribute('src')){
                    let attrs = el.getAttributeNames();
                    let tag = document.createElement('script');
                    for(let i = 0; i < attrs.length; i++){
                        tag.setAttribute(attrs[i], el.getAttribute(attrs[i]));
                    }

                    el.parentNode.appendChild(tag);
                    el.parentNode.removeChild(el);
                } else {
                    Function(`'use strict';${el.innerText}`)();
                }
            });
        }catch(e) {
            console.error(`Error in embed Script:`, e);
        }
    }

    static fireIframeEventInContext(context, message, filter){

        if(window.navigator && typeof window.navigator.onLine === "boolean"){
            Embeds.toggleOfflineMessage( context, !window.navigator.onLine );
        }

        let selection = $(context).find(".element.embed[data-embedtype='file'], .element.embed[data-embedtype='url']");
        if(filter){
            selection = selection.filter(filter);
        }

        selection.find(".file-embed, .url-embed").each( (i, element) => {
            Embeds.fireIframeEvent(element, message);
        });
    }

    embedMessageReceived(message){
        let iframe,
            [spread_id, identifier] = message.identifier.split("__")
        ;
        switch(message.embed_message){
            case "IFRAME_LOADED":// ready event for the child iframes inside the spread
                let el = this.getIframeByIdentifier(identifier);
                if(el !== false) {
                    el.data("loaded", true);
                }
                iframe = this.getIframeByIdentifier(identifier, false);
                let element = iframe.closest(".element.embed");

                Embeds.fireIframeEvent( iframe.get(0) , {message: "INIT", data: this._getEmbedInjectData(false), parameters: element.data("parameters")});
                break;
            case "IFRAME_READY":// ready event for the child iframes inside the spread
                this.iframeReady( identifier );
                break;
            case "TOGGLE_ELEMENT":
                let i, elements = [], uuid;
                let spreadId = this.scene.spread.spread_id
                //check if the elements are prefixed and postfixed
                for(i = 0; i < message.data.elements.length; i++){
                    uuid = message.data.elements[i];
                    if( uuid.indexOf("uuid") === -1 ){
                        uuid = constructUUID(uuid, this.scene.spread.active_layout, spreadId);
                    }
                    elements.push(uuid);
                }

                let data = {
                    togglestate: {
                        elementIds: elements,
                        closeOption: message.data.closeOption,
                    },
                };
                this.scene.toggleState( data );
                break;
            case "GO_TO_SCENE":
                let selector;
                if(typeof message.data.scene === "number"){ // go to index
                    selector = ".scene[data-scene-index='"+message.data.scene+"']";
                }else{ // scene uuid or the string next or prev
                    if(message.data.scene === "next" || message.data.scene === "prev" ){
                        selector = message.data.scene.toUpperCase();
                    }else{
                        selector = constructSceneUUID(message.data.scene, this.scene.spread.active_layout, this.scene.spread.spread_id);
                    }
                }

                this.scene.spread.sceneLink(selector);
                break;
            case "GO_TO_SPREAD":
                Links.sendInternalLinkMessage(message.data, this.scene.spread.getSettings());
                break;
            case "ACTION_INTERFACE":
                Links.sendInterfaceLinkMessage(message.data.action, this.scene.spread.getSettings());
                break;
            case "TRACK_EVENT":
                iframe = this.getIframeByIdentifier(identifier, false);
                let label = iframe.closest(".element.embed").data('label'),
                    value = message.data.value || 'no-value'
                ;
                UserEvents.sendEventUpdate('Embeds', label, value, this.scene.spread.getSettings(), iframe);
                break;
        }
    }

    /**
     * Fire event in child iframe like the iframe component
     *
     * @method fireIframeEvent
     * @param element
     * @param message
     */
    static fireIframeEvent(element, message){
        let jq_element = $(element),
            data = jq_element.data()
        ;


        if(data.ready === true || (data.loaded === true && message && message.message === "INIT")){
        // if(data.ready === true && data.messages && data.messages.hasOwnProperty("INIT")){
            if(element.contentWindow){
                if(typeof message === 'string'){
                    message = Embeds.createMessage(message);
                }

                if(Embeds.checkMessage(data, message.message)){
                    element.contentWindow.postMessage(message,"*");
                }

                jq_element.data("messages", data.messages);
            }
        }else{
            if(typeof data.queue === "undefined" ){
                data.queue = [];
            }
            data.queue.push(message);
            jq_element.data("queue", data.queue);
        }
    }

    static checkMessage(data, message){
        if( ! data.messages ){ // messages not set yet.
            data.messages = {};
        }else{
            if( data.messages[message] ){ // current message already send.
                return false;
            }
        }

        //switch message and set its counterpart to false
        switch(message){
            case "START":
                data.messages.STOP = false;
                break;
            case "STOP":
                data.messages.START = false;
                data.messages.ANIMATION_END = false;
                data.messages.ANIMATION_START = false;
                data.messages.TOGGLE_OFF = false;
                data.messages.TOGGLE_ON = false;
                break;
            case "ANIMATION_START":
                data.messages.ANIMATION_END = false;
                data.messages.TOGGLE_OFF = false;
                break;
            case "ANIMATION_END":
                data.messages.ANIMATION_START = false;
                data.messages.TOGGLE_OFF = false;
                break;
            case "TOGGLE_ON":
                data.messages.TOGGLE_OFF = false;
                break;
            case "TOGGLE_OFF":
                data.messages.TOGGLE_ON = false;
                data.messages.ANIMATION_START = false;
                data.messages.ANIMATION_END = false;
                break;
        }

        //set the current message to true
        data.messages[message] = true;

        return true;
    }

    /**
     * Get the embedded iframe with the given identifier
     * @param {string} identifier
     * @param {boolean} iframe_only
     * @returns {*}
     */
    getIframeByIdentifier( identifier, iframe_only ){
        let iframe = this.scene.runSelector('#'+identifier).find('iframe.file-embed, iframe.url-embed');
        if(iframe.length > 0){
            if(iframe_only){
                return iframe.get(0);
            }else{
                return iframe;
            }
        }
        return false;

    }

    iframeReady(identifier) {
        let el = this.getIframeByIdentifier(identifier);
        if(el !== false) {
            let queue = el.data("ready", true).data("queue");
            if (queue && el.get(0).contentWindow) {
                //loop message queue and post messages.
                for (let i = 0; i < queue.length; i++) {
                    Embeds.fireIframeEvent(el.get(0), queue[i]);
                }
            }
        }
    }

    /**
     * Embeds actions that can be triggered by other elements
     *
     * @method embedAction
     * @param {jQuery.EventObject} event
     * @param {Object} data
     */
    // EmbedAction(event, data){
    //     event.stopPropagation();
    //     switch(data.action){
    //         case "restart":
    //             console.debug("restart embed");
    //             break;
    //         default:
    //             console.log("No action bound to: ", data.action);
    //             break;
    //     }
    // }

    /**
     * Get the data that will be injected into the embed iframe.
     *
     * @method _getEmbedInjectData
     * @param {Boolean} issues_json
     * @private
     * @return {Object}
     */
    _getEmbedInjectData(issues_json){
        let query_string = this._getParsedQueryString() || {}, settings, spread_settings = this.scene.spread.getSettings();
        settings = {
            issues : {}
        };
        let replaceables = {
            replaceables: this.scene.spread.getOption('replaceables'),
            globals : this.scene.spread.getGlobalData()
        };

        return $.extend(true, {}, query_string, spread_settings._spread_globals, settings, replaceables );
    }

    _getParsedQueryString(){
        if(!this.parsed_query_string && location.search.indexOf("?") > -1){
            let i, key_value, query_str, query_split;
            //remove the ?
            query_str = location.search.substr(1);
            //split the query in key=value pairs
            query_split = query_str.split("&");
            //loop all pairs to create an object with property(key) = value
            this.parsed_query_string = {};
            for(i = 0; i < query_split.length; i++){
                key_value = query_split[i].split("=");
                this.parsed_query_string[String(key_value[0])] = key_value[1];
            }
        }
        return this.parsed_query_string;
    }

    filterIframeContext(i, el, viewport_height, check_for_animation = true){
        let selector = ".hidden";
        if(check_for_animation){
            selector += ", .has_animation_in, .has_animation_open";
        }
        if( $(el).closest(selector).length === 0){
            return el.getBoundingClientRect().top < viewport_height * 0.7; // over the 70% line
        }
        return false;
    }

    static toggleOfflineMessage(context, show){
        let selection = context.find(".url-embed").filter(function(i, el){
            return el.getAttribute("data-src").indexOf("http") > -1;
        }).siblings(".embed-offline-message");
        if(show){
            selection.show();
        }else{
            selection.hide();
        }
    }

    static createMessage(body) {
        return {message: body};
    }

    toggleOnByScroll(){
        if( !this.ticking ) {
            this.ticking = true;
            requestAnimationFrame( () => this.toggleOnByViewport());
        }
    }

    /**
     * Send the TOGGLE_ON message when the elements top is over the 70% (from top) viewport line.
     */
    toggleOnByViewport() {
        let embeds, i, rect, w_70 = this.scene.spread.getWindowHeight() * 0.7;
        //get all "visible" embeds.
        embeds = this.scene.runSelector(".embed[data-embedtype='file'], .embed[data-embedtype='url']").filter(function(i, el){
            return $(el).closest(".hidden, .has_animation_scroll").length === 0;
        });

        //check whether they are in the viewport for atleast 30% of its own height
        for(i = 0; i < embeds.length; i++){

            rect = embeds[i].getBoundingClientRect();

            if( rect.top < w_70 ){ // over the 70% line
                //send start
                Embeds.fireIframeEvent($(embeds[i]).children(".file-embed, .url-embed")[0], "TOGGLE_ON");
            }
        }

        // allow further rAFs to be called
        this.ticking = false;
    }

}
